export default [
  {
    path: "/settings/users-and-groups",
    name: "UsersAndGroups",
    // component: () => import("@/views/3pl/Settings/UsersAndGroups/index"),
    component: () => import("@/views/3pl/Users/Index"),
  },
  {
    path: "/settings/users-and-groups/edit-group",
    name: "EditGroup",
    component: () => import("@/views/3pl/Users/EditGroup"),
    // component: () => import("@/views/3pl/Settings/UsersAndGroups/EditGroup"),
  },
  {
    path: "/settings/users-and-groups/view-group",
    name: "EditGroup",
    component: () => import("@/views/3pl/Users/viewGroup"),
    // component: () => import("@/views/3pl/Settings/UsersAndGroups/EditGroup"),
  },
  {
    path: "/settings/users-and-groups/add-user",
    name: "NewUser",
    component: () => import("@/views/3pl/Settings/UsersAndGroups/NewUser"),
  },
  {
    path: "/settings/users-and-groups/edit-user",
    name: "EditUser",
    component: () => import("@/views/3pl/Settings/UsersAndGroups/EditUser"),
  },
  {
    path: "/settings/users-and-groups/single-group",
    name: "SingleGroup",
    component: () => import("@/views/3pl/Settings/UsersAndGroups/SingleGroup"),
  },
  {
    path: "/settings/users-and-groups/new-group",
    name: "NewGroup",
    component: () => import("@/views/3pl/Settings/UsersAndGroups/NewGroup"),
  },
];
